<template>
  <div>
    <p-button @click.native.prevent="$router.back()" outline> &larr; {{ $t('Back') }} </p-button>
  </div>
</template>

<script>
export default {
  name: 'BackButton',
};
</script>

<style scoped></style>
